<template>
  <b-container fluid>
    <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mb-3">
      <h5 class="text-ow-secondary mb-2 mb-md-0">Usuarios</h5>
      <div class="d-flex flex-column flex-md-row align-items-md-center">
        <b-input-group class="users-search mb-2 mb-md-0 mr-md-2">
          <b-form-input
            v-model="filter"
            type="search"
            placeholder="Buscar usuario..."
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-button variant="ow-primary"
          @click="showingCreateOrUpdate = true"
        >Agregar usuario</b-button>
      </div>
    </div>
    <b-table
      :items="localUsers"
      :fields="fields"
      :busy="loading"
      :stacked="'md'"
      :filter="filter"
      show-empty
      empty-filtered-text="No se encontraron usuarios con ese criterio"
      empty-text="No hay usuarios registrados"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-3" type="grow" small></b-spinner>
          <strong>Cargando...</strong>
        </div>
      </template>
      <template #head(actions)>
        <div class="text-right">
          <b-form-checkbox
            id="with-trashed"
            v-model="withTrashed"
            name="with-trashed"
            :value="true"
            :unchecked-value="false"
            switch
          >
            Incluir eliminados
          </b-form-checkbox>
        </div>
      </template>
      <template #cell(profile)="{ item }">
        <b-badge variant="ow-primary">
          {{ item.profile }}
        </b-badge>
      </template>
      <template #cell(actions)="{ item }">
        <div class="d-flex justify-content-end" v-if="item.deleted_at">
          <b-button variant="ow-primary" size="sm" class="border border-ow-secondary d-flex align-items-center"
            @click="restore(item)"
            :disabled="restoring === item.id"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z">
              </path>
            </svg>
          </b-button>
        </div>
        <div class="d-flex justify-content-end" v-else>
          <b-button variant="ow-primary" size="sm" class="border border-ow-secondary d-flex align-items-center"
            @click="changePassword(item)"
          >
            <svg class="w-4 h-4 text-ow-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z">
              </path>
            </svg>
          </b-button>
          <b-button variant="ow-primary" size="sm" class="border border-ow-secondary d-flex align-items-center mx-2"
            @click="edit(item)"
          >
            <svg class="w-4 h-4 text-ow-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
              </path>
            </svg>
          </b-button>
          <b-button variant="ow-primary" size="sm" class="border border-ow-secondary d-flex align-items-center"
            @click="showDeleteMsgConfirm(item)"
            :disabled="item.id === deleting"
          >
            <svg class="w-4 h-4 text-ow-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
              </path>
            </svg>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-modal
      v-model="showingCreateOrUpdate"
      @hidden="createOrUpdateModalHidden"
      hide-footer
      :title="editing ? editing.name : 'Nuevo usuario'"
    >
      <new-user :user="editing"
        @save="save"
        :saving="saving"
      ></new-user>
    </b-modal>
    <b-modal
      v-model="showingChangePassword"
      @hidden="changePasswordModalHidden"
      hide-footer
      title="Cambio de contraseña"
    >
      <change-password :user="editing"
        @change="change"
        :saving="saving"
      ></change-password>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios'
import NewUser from './../components/users/NewUser.vue'
import ChangePassword from './../components/users/ChangePassword.vue'

export default {
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  components: {
    NewUser,
    ChangePassword
  },
  data() {
    return {
      localUsers: [],
      showingCreateOrUpdate: false,
      showingChangePassword: false,
      editing: null,
      saving: false,
      deleting: null,
      withTrashed: false,
      restoring: null,
      loading: false,
      filter: ''
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'user_name',
          label: 'Nombre de usuario'
        },
        {
          key: 'email',
          label: 'Correo electrónico'
        },
        {
          key: 'profile',
          label: 'Perfil'
        },
        {
          key: 'created_at',
          label: 'Fecha de alta'
        },
        {
          key: 'actions',
          label: ' '
        }
      ]
    }
  },
  mounted () {
    this.localUsers = this.users;
  },
  methods: {
    edit(item) {
      this.editing = item
      this.showingCreateOrUpdate = true
    },
    changePassword(item) {
      this.editing = item
      this.showingChangePassword = true
    },
    createOrUpdateModalHidden() {
      this.editing = null
    },
    changePasswordModalHidden() {
      this.editing = null
    },
    showDeleteMsgConfirm(item) {
      this.$bvModal.msgBoxConfirm(`Esta seguro que desea eliminar a ${item.name}?`, {
        title: 'Confirmación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si, confirmar',
        cancelTitle: 'Cancelar',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        console.log(value)
        if (value) {
          this.deleteUser(item)
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    showRestoreMsgConfirm(item) {
      this.$bvModal.msgBoxConfirm(`Esta seguro que desea restaurar a ${item.name}?`, {
        title: 'Confirmación',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si, confirmar',
        cancelTitle: 'Cancelar',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        console.log(value)
        if (value) {
          this.restore(item)
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    async save(userData) {
      this.saving = true;
      try {
        if (this.editing) {
          const { data } = await axios.put(`/users/${this.editing.id}`, userData);
          this.localUsers = this.localUsers.map(u => {
            if (u.id === this.editing.id) {
              return data;
            }

            return u;
          })
          
        } else {
          const { data } = await axios.post('/users', userData);
          this.localUsers.unshift(data);
        }
        this.showingCreateOrUpdate = false
      } catch (error) {
        console.log(error);
        
        if(error.response.data.errors) {
          var errors = Object.values(error.response.data.errors).map(e => e[0]).join('<br>');

          this.$swal({
            icon: "error",
            title: error.response.data.message,
            html: errors ? 'Por favor corrige los siguientes errores: <br>' + errors : 'Error inesperado',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonColor: "#d33",
            cancelButtonText: "Cerrar",
          });
        }

      } finally {
        this.saving = false;
      }
    },
    async change(passData) {
      this.saving = true;

      try {
        await axios.post(`/users/${this.editing.id}/change-password`, passData);
        this.showingChangePassword = false
      } catch (error) {

      } finally {
        this.saving = false;
      }
    },
    async deleteUser(user) {
      this.deleting = user.id;
      try {
        await axios.delete(`/users/${user.id}`);
        this.localUsers = this.localUsers.filter(u => u.id !== user.id)
      } catch (err) {

      } finally {
        this.deleting = null
      }
    },
    async restore(user) {
      this.restoring = user.id;
      try {
        const { data } = await axios.post(`/users/${user.id}/restore`);
        this.localUsers = this.localUsers.map(u => {
          if (u.id === user.id) {
            return data;
          }

          return u;
        })
      } catch (err) {

      } finally {
        this.restoring = null
      }
    }
  },
  watch: {
    async withTrashed(v) {{
      this.loading = true
      const { data } = await axios.get('/users', {
        params: {
          trashed: v ? 1 : 0
        }
      })

      this.localUsers = data
      this.loading = false
    }}
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .users-search {
    width: 400px;
  }
}
</style>
